(function(){
 'use strict';
 function mount(root){
  if(!root||root.dataset.mounted)return;root.dataset.mounted='true';
  var preview=root.dataset.mode==='preview',finished=false,hideTimer,guard,observer;
  function finish(){if(finished)return;finished=true;clearTimeout(guard);root.dataset.state='done';hideTimer=setTimeout(function(){root.hidden=true;},250);if(observer)observer.disconnect();}
  function reveal(){clearTimeout(hideTimer);clearTimeout(guard);finished=false;root.hidden=false;root.removeAttribute('data-state');guard=setTimeout(finish,5000);}
  function pageReady(){requestAnimationFrame(function(){requestAnimationFrame(finish);});}
  if(preview){
   function check(){if(/^(ready|error)$/.test(document.documentElement.dataset.egPreviewState||''))finish();}
   observer=new MutationObserver(check);observer.observe(document.documentElement,{attributes:true,attributeFilter:['data-eg-preview-state']});check();
   guard=setTimeout(function(){if(!finished){var label=root.querySelector('.eg-brand-loader__label');if(label)label.textContent='Still loading your preview…';}},15000);
  }else{
   // The page loader never waits for every review image, video or third-party app.
   guard=setTimeout(finish,5000);
   if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',pageReady,{once:true});else pageReady();
   window.addEventListener('pageshow',function(){finish();});
   document.addEventListener('click',function(event){
    if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    var link=event.target.closest&&event.target.closest('a[href]');if(!link||link.hasAttribute('download')||link.target&&link.target!=='_self')return;
    var url;try{url=new URL(link.href,location.href);}catch{return;}
    if(url.origin!==location.origin||url.pathname===location.pathname&&url.search===location.search||/^\/(?:checkouts?|account|customer_authentication|challenge|admin)(?:\/|$)/.test(url.pathname))return;
    reveal();
   });
   window.addEventListener('pagehide',function(){clearTimeout(guard);root.hidden=true;finished=true;});
  }
 }
 document.querySelectorAll('[data-eg-brand-loader]').forEach(mount);
})();
